import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/DiplomadoAvanzado/Header';
import CourseDetails from '../components/DiplomadoAvanzado/CourseDetails';
import CourseModules from '../components/DiplomadoAvanzado/CourseModules';
import CallToAction from '../components/DiplomadoAvanzado/CallToAction';
import CarruselFotos from '../components/DiplomadoAvanzado/CarruselFotos'

const DiplomadoWebPage = () => {
  

  return (
    <div>
      {/* SEO */}
      <Helmet>
        <title>Diplomado en Ultrasonografía Diagnóstica - IMDI Tuxtla</title>        
        <meta name="description" content="Capacítate en ultrasonografía diagnóstica con IMDI Tuxtla. Diplomados en ultrasonido, ecografía y doppler materno fetal con expertos médicos." />
        <meta name="keywords" content="diplomados en ultrasonografía, ultrasonido diagnóstico, ecografía médica, doppler materno fetal, maestría en ultrasonografía" />
        <meta name="author" content="IMDI Tuxtla" />
        <link rel="canonical" href="https://imdituxtla.com.mx/diplomado-avanzado" />
      </Helmet>

      <Header />
      <CourseDetails />
      <CourseModules />
      <CarruselFotos />
      <CallToAction />
    </div>
  );
};

export default DiplomadoWebPage;
